import { useEffect, useState } from "react";
import Slider from "react-slick";
import Box from "@mui/material/Box";
// helpers
import { getCurrentDevice } from "../../../../../common/utils/helpers/currentDeviceHelpers/getCurrentDevice";

interface SwissTravelPassOfferSelectionTypes {
  handleSelectedTravelPassOffer: (offer: any, offerCode: string) => void;
  quickSelectParam: string | null;
  travelPassOffers: Array<any>;
  selectedTravelPassOffer: any;
}

const slidesToShowDesktop: number = 4;
const slidesToShowMobile: number = 3;

export default function SwissTravelPassOfferSelection({
  handleSelectedTravelPassOffer,
  quickSelectParam,
  travelPassOffers,
  selectedTravelPassOffer
}: SwissTravelPassOfferSelectionTypes) {
  const slidesToShow = Math.min(
    getCurrentDevice() === "phone" ? slidesToShowMobile : slidesToShowDesktop,
    travelPassOffers.length
  );

  // disable infinite if not enough items
  const infinite = travelPassOffers.length > slidesToShow;

  const settings = {
    arrows: true,
    dots: true,
    infinite: infinite,
    speed: 500,
    slidesToShow,
    slidesToScroll: slidesToShow,
    vertical: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: Math.min(slidesToShowMobile, travelPassOffers.length),
          slidesToScroll: Math.min(slidesToShowMobile, travelPassOffers.length)
        }
      }
    ]
  };

  const [initialSlide, setInitialSlide] = useState(-1); // Should be 0 or bigger in order to show Slider

  useEffect(() => {
    // Handling initial slide, 0 if coming
    if (quickSelectParam) {
      const selectedIndex = travelPassOffers?.findIndex((offer: any) => offer?.offer_code === quickSelectParam);
      const slidesToShow = getCurrentDevice() === "phone" ? slidesToShowMobile : slidesToShowDesktop;
      // Formula for moving slider to the index of selected SBB selection
      const getInitialSliderIndex = Math.floor(selectedIndex / slidesToShow) * slidesToShow;

      setInitialSlide(getInitialSliderIndex);
    } else {
      setInitialSlide(0);
    }
  }, [travelPassOffers]);

  return (
    <Box mt={{ xs: 3, sm: 2 }} mb={1}>
      <Box className="sbb-quick-selection-title">Swiss Travel Pass</Box>
      <Box ml={{ xs: 2, sm: 1 }} mr={{ xs: 2, sm: 1 }}>
        {initialSlide >= 0 && travelPassOffers?.length > 0 && (
          <Slider {...settings} initialSlide={initialSlide}>
            {travelPassOffers?.length > 0 &&
              travelPassOffers?.map((offer: any) => (
                <Box
                  key={offer?.offer_code}
                  className={`sbb-quick-selection-item ${
                    offer?.offer_code === selectedTravelPassOffer?.offer_code ? "sbb-quick-selection-item__active" : ""
                  }`}
                  onClick={() => handleSelectedTravelPassOffer(offer, offer?.offer_code)}
                >
                  {offer?.name}
                </Box>
              ))}
          </Slider>
        )}
      </Box>
    </Box>
  );
}
